(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gna-split-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gna-hero-media')) {
 customElements.define('gna-hero-media', class extends HTMLElement {
  connectedCallback() {
   if (this.bound) return;
   this.bound = true;
   const template = this.querySelector(matchMedia('(max-width:699px)').matches ? '[data-mobile]' : '[data-desktop]');
   if (!template) return;
   const video = template.content.querySelector('video').cloneNode(true);
   video.muted = true;
   video.controls = false;
   video.removeAttribute('controls');
   video.autoplay = true;
   video.playsInline = true;
   video.preload = 'auto';
   video.setAttribute('aria-label', 'GNA skincare video');
   this.append(video);
   video.setAttribute('disablepictureinpicture', '');
   video.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
   const play = () => { if (!document.hidden) video.play().catch(() => {}); };
   video.addEventListener('playing', () => video.classList.add('is-playing'));
   video.addEventListener('error', () => video.classList.remove('is-playing'));
   video.addEventListener('canplay', play);
   this.onVisibility = () => document.hidden ? video.pause() : play();
   document.addEventListener('visibilitychange', this.onVisibility);
   this.video = video;
   const hero = this.closest('.gna-split');
   const syncOverlay = (time = video.currentTime) => hero.classList.toggle('is-video-outro', time >= 17.45);
   video.addEventListener('timeupdate', () => syncOverlay());
   video.addEventListener('seeked', () => syncOverlay());
   video.addEventListener('error', () => hero.classList.remove('is-video-outro'));
   if (video.requestVideoFrameCallback) {
    const onFrame = (_now, metadata) => {
     syncOverlay(metadata.mediaTime);
     if (this.isConnected) this.overlayFrame = video.requestVideoFrameCallback(onFrame);
    };
    this.overlayFrame = video.requestVideoFrameCallback(onFrame);
   }
   syncOverlay();
   play();
  }
  disconnectedCallback() { document.removeEventListener('visibilitychange', this.onVisibility); this.video?.pause(); if (this.overlayFrame) this.video?.cancelVideoFrameCallback(this.overlayFrame); }
 });
}

  } catch(e) { console.error(e); }
})();
})();
